/**
 * SendMail Widget - Migrierte Version für das neue Widget-System
 */
import React, { useState, useEffect } from 'react';
import { fetchApi } from "../../../utils/DatabaseHelper";
import './SendMail.scss';

const SendMail = ({ config, data, onDataChange, onConfigChange }) => {
  const [toMail, setToMail] = useState('');

  useEffect(() => {
    fetchApi("einstellungen", "SendMail").then(data => {
      setToMail(data.toMail);
    });
  }, []);

  const href = `mailto:${toMail}`;

  return (
    <div className="send-mail-widget">
      <div className="col-auto">
        <div className="mail-widget">
          <a href={href}>
            <div className="info-box">
              <span className="info-box-icon bg-info">
                <i className="far fa-envelope"></i>
              </span>
              <div className="info-box-content text-center">
                <h6 className="m-0">Info Mail an <br/>DiVoKa</h6>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
  );
};

export default SendMail;
